
import axios from 'axios'
import {historyEventService} from './httpService'
import {historyService} from './historyService'
import {globalService} from '@/service/globalService'
export default class CreateNavService {
  constructor (module, url1, url2, dictionary) {
    this.module = module
    this.url1 = url1
    this.url2 = url2
    this.dictionary = dictionary
  }

  create () {
    let me = this
    let param = me.module.$route.params
    return axios.all([
      historyEventService.loadColums(me.url1),
      historyEventService.loadColums(me.url2)
    ])
      .then(axios.spread(function (timeRes, typeRes) {
        let menuData = historyService.handleTwoMenu([timeRes.data, typeRes.data], param, me.dictionary)
        me.module.navList = menuData
        let resData = timeRes.data.Data
        if (resData && resData.length && resData[0].StartMonth && resData[0].EndMonth) {
          me.module.timeDict = resData
        }
        me.module.pageLoading = false
      }))
  }

  getDocumentsData () {
    let me = this
    me.module.nameList = []
    me.module.moreList = []
    me.module.gambitList = {}
    me.module.documentData = {}
    axios.all([
      historyEventService.loadColums(me.url1),
      historyEventService.loadColums(me.url2, me.dictionary)
    ])
      .then(axios.spread(function (columnRes, documentRes) {
        me.module.gambitList = columnRes.data
        me.module.documentData = documentRes.data
        if (me.module.routeList) {
          me.module.routeList.forEach(item => {
            if (item.type === 'column') {
              item.name = columnRes.data.Name
            } else if (item.type === 'propType') {
              item.name = window.dictionaryConfig.propType[item.url]
            }
          })
        }
        me.module.moduleLoading = false
      }))
  }

  createOneMenu () {
    let me = this
    let param = me.module.$route.params
    historyEventService.loadColums(me.url1)
      .then(function (res) {
        let menuData = historyService.handleMenuData(res.data, param, me.dictionary)
        me.module.navList = [menuData]
        me.module.pageLoading = false
      }, error => globalService.showErrNofify(error))
  }
}



// WEBPACK FOOTER //
// ./src/service/createNavService.js